import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import authReducer from "./authReducer";
import currentReducer from "./currentReducer";
export default combineReducers({
    form:formReducer,
    auth:authReducer,
    current:currentReducer
}) 
